import {
  Maybe,
  Money,
  PayOverTimeDetailsResult,
  PayOverTimeDetailsResultTypenames,
  SlTitledListComponent,
} from '@varo/graphql-schema-types';
import FetchPayOverTimeDetails from 'services/graphql/queries/FetchPayOverTimeDetails';
import { useQuery } from 'urql';

export interface PayOverTimeDetails {
  outstandingBalance?: Maybe<Money>;
  openLoans?: Maybe<SlTitledListComponent[] | null>;
  closedLoans?: Maybe<SlTitledListComponent[] | null>;
  openLoansCount: number;
}

const usePayOverTimeDetails = () => {
  const [{ data, fetching, error }, refetch] = useQuery<{
    payOverTimeDetails: PayOverTimeDetailsResult;
  }>({
    query: FetchPayOverTimeDetails,
    requestPolicy: 'cache-and-network',
  });

  const potDetailsData =
    data?.payOverTimeDetails?.__typename ===
    PayOverTimeDetailsResultTypenames.PayOverTimeDetailsSuccess
      ? data.payOverTimeDetails
      : null;

  const potDetailsError =
    data?.payOverTimeDetails?.__typename ===
    PayOverTimeDetailsResultTypenames.PayOverTimeDetailsError
      ? data.payOverTimeDetails
      : null;

  const combinedError = error || potDetailsError;

  const resultsObj: PayOverTimeDetails = {
    outstandingBalance: potDetailsData?.outstandingBalance,
    openLoans: potDetailsData?.openLoans,
    closedLoans: potDetailsData?.closedLoans,
    openLoansCount: potDetailsData?.openLoans[0]?.children?.length || 0,
  };

  return {
    error: combinedError,
    resultsObj,
    fetching: fetching && !data,
    refetch,
  };
};

export default usePayOverTimeDetails;
